import React, { useRef } from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    nvl,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem11,
} from '../../../business-components/Grid/Grid'

//import {
//    RichTextEditorViewer
//} from '../../../business-components/RichTextEditor/RichTextEditorViewer'

import {
    RichTextEditorViewerPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorViewerPadrao'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    calcValorPresenteDeficitSimulacaoMensalValorAporteMensalPreservarReservaAposentadoria,
} from '../estudo-chart/HipotesesRetornoRealProjetoVidaSonhoTracarMetaChartService'

import {
    calculaMaiorPeriodoGraficoIdadesCenarios,
    calculaMaiorPeriodoGraficoIdadesEstudos,
} from '../estudo-form/EstudoServiceCalculo'

import {
    processaValoresDefaultIniciaisProtecaoSugeridaClienteConjuge
} from '../estudo-form/EstudoServiceProtecaoSugeridaClienteConjuge'

import {
    possuiCotacaoSeguroVidaApenasComparacaoPreco,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import {
    obtemPagina,
    paginas,
    reportLinhasSemGrafico,
    reportLinhasComGrafico,
    calculaJsonPaginaPaginaAdicional,
    calcularPaginas,
    substituirVariaveis,
} from './EstudoReportService'

import EstudoReportOQueEsperarDesseTrabalho from './EstudoReportOQueEsperarDesseTrabalho'

import EstudoFormObjetivos from '../estudo-form/EstudoFormObjetivos'

import EstudoReportConferenciaDados from './EstudoReportConferenciaDados'

import EstudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo from '../estudo-form/EstudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo'

import GestaoPatrimonialFormEstruturaFamiliar from '../gestaoPatrimonial-form/GestaoPatrimonialFormEstruturaFamiliar'

import CarteiraInvestimentosChart from '../estudo-chart/CarteiraInvestimentosChart'

import ProjecaoSucessaoVitaliciaChart from '../estudo-chart/ProjecaoSucessaoVitaliciaChart'

import EstudoFormProjecaoSucessaoVitalicia from '../estudo-form/EstudoFormProjecaoSucessaoVitalicia'

import EstudoFormResumoSeguroVidaCotacao from '../estudo-form/EstudoFormResumoSeguroVidaCotacao'

import EstudoFormTabelaEvolucaoValorResgate from '../estudo-form/EstudoFormTabelaEvolucaoValorResgate'

import EstudoFormTabelaEvolucaoCS from '../estudo-form/EstudoFormTabelaEvolucaoCS'

import EstudoFormTabelaEvolucaoCancelamentoApolice from '../estudo-form/EstudoFormTabelaEvolucaoCancelamentoApolice'

import TabelaEvolucaoValorResgateChart from '../estudo-chart/TabelaEvolucaoValorResgateChart'

import AnaliseInvestimentoVersusSeguroVidaInteiraChart from '../estudo-chart/AnaliseInvestimentoVersusSeguroVidaInteiraChart'

import AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart from '../estudo-chart/AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart'

import AnalisePatrimonialChart from '../estudo-chart/AnalisePatrimonialChart'

import GestaoPatrimonialFormResumoPatrimonial from '../gestaoPatrimonial-form/GestaoPatrimonialFormResumoPatrimonial'

import EstudoFormGarantiasPatrimonioImobilizadoDetalhadoBensMoveisImoveis from '../estudo-form/EstudoFormGarantiasPatrimonioImobilizadoDetalhadoBensMoveisImoveis'

import EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios from '../estudo-form/EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios'

import EstudoFormGarantiasRecursosFinanceirosDetalhado from '../estudo-form/EstudoFormGarantiasRecursosFinanceirosDetalhado'

import ReceitaAnualChart from '../estudo-chart/ReceitaAnualChart'

import {
    AIFT
} from '../aiFT-form/AIFTComp'

import EstudoFormGarantiasReceitaMensalDetalhada from '../estudo-form/EstudoFormGarantiasReceitaMensalDetalhada'

import DespesaAnualChart from '../estudo-chart/DespesaAnualChart'

import EstudoFormDespesasDespesaMensalDetalhada from '../estudo-form/EstudoFormDespesasDespesaMensalDetalhada'

import BalancoReceitaXDespesaAnualChart from '../estudo-chart/BalancoReceitaXDespesaAnualChart'

import ConsumoReservaAposentadoriaChart from '../estudo-chart/ConsumoReservaAposentadoriaChart'

import EstudoReportDiagnosticoAposentadoriaChart from './EstudoReportDiagnosticoAposentadoriaChart'

import DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart from '../estudo-chart/DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart'

import EstudoFormEvolucaoReservaFinanceiraEstudo from '../estudo-form/EstudoFormEvolucaoReservaFinanceiraEstudo'

import HipotesesRetornoRealChart from '../estudo-chart/HipotesesRetornoRealChart'

import EstudoReportProjetoVidaSonhoTracarMeta from './EstudoReportProjetoVidaSonhoTracarMeta'

import PrevidenciaPrivadaFormPrevidenciaPrivada from '../previdencia-privada/PrevidenciaPrivadaFormPrevidenciaPrivada'

import ConsorcioFormSimulacaoItemReport from '../consorcio-form/ConsorcioFormSimulacaoItemReport'

//import ConsorcioFormSimulacao from '../consorcio-form/ConsorcioFormSimulacao'

import ComparacaoFinanciamentosChart from '../estudo-chart/ComparacaoFinanciamentosChart'

import EstudoFormComparacaoFinanciamentoTabelaDetalhe from '../estudo-form/EstudoFormComparacaoFinanciamentoTabelaDetalhe'

import EstudoFormProtecaoSugerida from '../estudo-form/EstudoFormProtecaoSugerida'

import EstudoReportDespesasAcumuladas from './EstudoReportDespesasAcumuladas'

import EstudoFormSucessaoVitalicia from '../estudo-form/EstudoFormSucessaoVitalicia'

import EstudoReportResumoNecessidadeProtecao from './EstudoReportResumoNecessidadeProtecao'

import EstudoFormComposicaoInventario from '../estudo-form/EstudoFormComposicaoInventario'

import EstudoFormDespesasDiaDiaDespesasVitalicias from '../estudo-form/EstudoFormDespesasDiaDiaDespesasVitalicias'

import EstudoFormDespesasEducacao from '../estudo-form/EstudoFormDespesasEducacao'

import EstudoFormDespesasFinanciamento from '../estudo-form/EstudoFormDespesasFinanciamento'

import EstudoFormDespesasDiaDiaDespesasTemporarias from '../estudo-form/EstudoFormDespesasDiaDiaDespesasTemporarias'

import EstudoFormProjetoVidaSonho from '../estudo-form/EstudoFormProjetoVidaSonho'

import EstudoFormGarantiasPatrimonioImobilizado from '../estudo-form/EstudoFormGarantiasPatrimonioImobilizado'

import EstudoFormGarantiasReceitaMensal from '../estudo-form/EstudoFormGarantiasReceitaMensal'

import EstudoFormGarantiasRecursosFinanceiros from '../estudo-form/EstudoFormGarantiasRecursosFinanceiros'

import EstudoFormSeguroVida from '../estudo-form/EstudoFormSeguroVida'

import MapaFinanceiroFormGrafico from '../mapaFinanceiro-form/MapaFinanceiroFormGrafico'

import ComparacaoCenariosEstudosChart from '../estudo-chart/ComparacaoCenariosEstudosChart'

import EstudoFormComparacaoCenariosEstudos from '../estudo-form/EstudoFormComparacaoCenariosEstudos'

import EstudoFormConsideracoesFinais from '../estudo-form/EstudoFormConsideracoesFinais'

import DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart from '../estudo-chart/DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart'

import SimulacaoFinanceiraFormEvolucaoReservaFinanceira from '../simulacaoFinanceira-form/SimulacaoFinanceiraFormEvolucaoReservaFinanceira'

import EstudoReportContainer from './EstudoReportContainer'

import EstudoReportPage from './EstudoReportPage'

import EstudoReportPageCapa from './EstudoReportPageCapa'

import EstudoReportCapaPadrao from './EstudoReportCapaPadrao'

import EstudoReportDisclaimer from './EstudoReportDisclaimer'

import './EstudoReport.css'



const EstudoReport = ({ variaveisGlobais, values, handleChange, handleSubmit, handleSubmitAutomatico, setFieldValue,
    estudo, vars, linhaFormList, modoApresentacaoRelatorio, exibirPagina }) => {

    let pagina = useRef(0)

    pagina.current = 0

    const jsonPaginaPaginaAdicional = calculaJsonPaginaPaginaAdicional(values, vars)

    if (!values.modoApresentacaoRelatorio || !pesquisaList(values.reportImprimir, values.modoApresentacaoRelatorio).id) {

        modoApresentacaoRelatorio(values.reportImprimir[0].id)
    }

    const report = !values.modoApresentacao



    const ProtecaoSugerida = ( { values, handleSubmitAutomatico, estudo } ) => { // replicado em EstudoReportPrimeiraReuniaoCliente

        processaValoresDefaultIniciaisProtecaoSugeridaClienteConjuge(values, handleSubmitAutomatico, estudo, 
            vars.jsonConfiguracao, true)

        return (
            
            <>
                <EstudoFormProtecaoSugerida
                    variaveisGlobais={variaveisGlobais} 
                    values={values}
                    estudo={estudo}
                    vars={vars}
                    titulo={tituloCliente(values)}
                    idClienteConjuge={HARDCODE.idFamiliarCliente}
                    report={report}
                />
                {dadosCompletosConjuge(values) &&
                ((
                    values.protecaoSugeridaCliente && values.protecaoSugeridaConjuge &&
                    values.protecaoSugeridaCliente.length + values.protecaoSugeridaConjuge.length < 10
                ) ||
                //values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ||
                values.modoApresentacao) && (
                    <div
                        className='mt-15'
                    >
                        <EstudoFormProtecaoSugerida
                            variaveisGlobais={variaveisGlobais} 
                            values={values}
                            estudo={estudo}
                            vars={vars}
                            titulo={tituloConjuge(values)}
                            idClienteConjuge={HARDCODE.idFamiliarConjuge}
                            report={report}
                        />
                    </div>
                )}
            </>
        )
    }


    const PaginaAdicionalTextoImagem = ({ linhaReportImprimir, indexItemPagina, linhaItemPagina, linhaContasInvestimentos }) => {

        return (
            <>
                {values.modoApresentacao
                    ?
                        <GridContainer
                            className='mt-5'
                        >
                            <GridItem11>
                                {/*
                                <RichTextEditorViewer
                                    content={linhaItemPagina.richText}
                                    paginaInteira={
                                        pesquisaList(jsonPaginaPaginaAdicional, 
                                            linhaReportImprimir.id.substring(HARDCODE.estudoFormPagina.length))
                                                .paginaInteira
                                    }
                                />
                                */}
                                <RichTextEditorViewerPadrao
                                    content={substituirVariaveis(linhaItemPagina.tipoItemPagina, linhaItemPagina.richText, values, estudo, linhaContasInvestimentos)}
                                    paginaInteira={
                                        indexItemPagina > 0 && linhaItemPagina.richText && linhaItemPagina.richText.indexOf('img src') === -1 && linhaItemPagina.margemTop < 0
                                            ?
                                                false
                                            :
                                                pesquisaList(jsonPaginaPaginaAdicional, 
                                                    linhaReportImprimir.id.substring(HARDCODE.estudoFormPagina.length))
                                                        .paginaInteira
                                    }
                                    capa={
                                        pesquisaList(jsonPaginaPaginaAdicional, 
                                            linhaReportImprimir.id.substring(HARDCODE.estudoFormPagina.length))
                                                .capa
                                    }
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                />
                            </GridItem11>
                        </GridContainer>
                    :
                        <>
                        {/*
                        <RichTextEditorViewer
                            content={linhaItemPagina.richText}
                            paginaInteira={
                                pesquisaList(jsonPaginaPaginaAdicional, 
                                    linhaReportImprimir.id.substring(HARDCODE.estudoFormPagina.length))
                                        .paginaInteira
                            }
                        />
                        */}
                        <RichTextEditorViewerPadrao
                            content={substituirVariaveis(linhaItemPagina.tipoItemPagina, linhaItemPagina.richText, values, estudo, linhaContasInvestimentos)}
                            paginaInteira={
                                indexItemPagina > 0 && linhaItemPagina.richText && linhaItemPagina.richText.indexOf('img src') === -1 && linhaItemPagina.margemTop < 0
                                    ?
                                        false
                                    :
                                        pesquisaList(jsonPaginaPaginaAdicional, 
                                            linhaReportImprimir.id.substring(HARDCODE.estudoFormPagina.length))
                                                .paginaInteira
                            }
                            capa={
                                pesquisaList(jsonPaginaPaginaAdicional, 
                                    linhaReportImprimir.id.substring(HARDCODE.estudoFormPagina.length))
                                        .capa
                            }
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            vars={vars}
                        />
                    </>
                }
            </>
        )
    }



    return (
        
        <EstudoReportContainer
            values={values}
            naoPermitirImprimir={values.formatoReport === HARDCODE.idFormatoReportApresentacao}
            conteudo={
                <>
                    {values.reportImprimir
                    .filter(
                        linhaReportImprimir => !values.modoApresentacao ||
                        linhaReportImprimir.id === values.modoApresentacaoRelatorio
                    )?.map((linhaReportImprimir, index) => {

                        return linhaReportImprimir.id === HARDCODE.estudoFormCapa ?

                                (
                                    values.modoApresentacao
                                        ?
                                            <GridContainer>
                                                <GridItem11
                                                    className='ml--10'
                                                >
                                                    <EstudoReportPageCapa
                                                        key={index}
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        conteudo={
                                                            <EstudoReportCapaPadrao
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                            />
                                                        }
                                                    />
                                                </GridItem11>
                                            </GridContainer>
                                        :
                                            <EstudoReportPageCapa
                                                key={index}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                conteudo={
                                                    <EstudoReportCapaPadrao
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                    />
                                                }
                                            />
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormOQueEsperarDesseTrabalho ?
                            
                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.oQueEsperarDesseTrabalho}
                                        conteudo={
                                            <EstudoReportOQueEsperarDesseTrabalho
                                                values={values}
                                                jsonConfiguracao={vars.jsonConfiguracao}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )
                            
                            : linhaReportImprimir.id === HARDCODE.estudoFormObjetivos &&
                            exibirPagina(HARDCODE.estudoFormObjetivos) ?

                                /*(
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.objetivosPrincipaisPreocupacoes}
                                        conteudo={
                                            <EstudoFormObjetivos
                                                values={values}
                                                report={report}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )*/
                                (
                                    values.objetivosPrincipaisPreocupacoesPFCMLP?.map((item, ind) => (
                                        item.richText && item.richText !== HARDCODE.richTextEditorVazio && (
                                            <EstudoReportPage
                                                key={ind}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={nvl(item.tituloPagina, LABEL.objetivosPrincipaisPreocupacoesPFCMLP)}
                                                conteudo={
                                                    <EstudoFormObjetivos
                                                        values={values}
                                                        report={report}
                                                        indPagina={ind}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        )
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoReportConferenciaDados ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.conferenciaDados}
                                        conteudo={
                                            <EstudoReportConferenciaDados
                                                values={values}
                                                report={report}
                                                vars={vars}
                                                somenteClienteConjugeFamiliares={false}
                                                somenteClienteConjugeFamiliaresTaxas={false}
                                                incluirObjetivos={false}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )
                                
                            : linhaReportImprimir.id === HARDCODE.estudoReportConferenciaDadosClienteConjugeFamiliares ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.conferenciaDados}
                                        conteudo={
                                            <EstudoReportConferenciaDados
                                                values={values}
                                                report={report}
                                                vars={vars}
                                                somenteClienteConjugeFamiliares={true}
                                                somenteClienteConjugeFamiliaresTaxas={false}
                                                incluirObjetivos={false}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoReportConferenciaDadosClienteConjugeFamiliaresObjetivos ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.conferenciaDados}
                                        conteudo={
                                            <EstudoReportConferenciaDados
                                                values={values}
                                                report={report}
                                                vars={vars}
                                                somenteClienteConjugeFamiliares={true}
                                                somenteClienteConjugeFamiliaresTaxas={false}
                                                incluirObjetivos={true}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoReportConferenciaDadosClienteConjugeFamiliaresTaxas ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.conferenciaDados}
                                        conteudo={
                                            <EstudoReportConferenciaDados
                                                values={values}
                                                report={report}
                                                vars={vars}
                                                somenteClienteConjugeFamiliares={false}
                                                somenteClienteConjugeFamiliaresTaxas={true}
                                                incluirObjetivos={false}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo &&
                            exibirPagina(HARDCODE.estudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo) ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={
                                            LABEL.planejamento + ' ' +
                                                values.planejamentoEspecializacaoPeriodoSabatico.descricaoEspecializacaoPeriodoSabatico
                                        }
                                        conteudo={
                                            <EstudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo
                                                values={values}
                                                estudo={estudo}
                                                report={report}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.gestaoPatrimonialFormEstruturaFamiliar &&
                            exibirPagina(HARDCODE.gestaoPatrimonialFormEstruturaFamiliar) ?

                                (
                                    <div
                                        key={index}
                                    >
                                        <EstudoReportPage
                                            //key={index}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.estruturaFamiliar}
                                            conteudo={
                                                <GestaoPatrimonialFormEstruturaFamiliar
                                                    values={values}
                                                    report={report}
                                                    clienteOuConjugeReport={HARDCODE.idFamiliarCliente}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />

                                        {values.percHerancaFamiliarDiferenteConjuge && (
                                            <EstudoReportPage
                                                //key={'conjuge' + index}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.estruturaFamiliar}
                                                conteudo={
                                                    <GestaoPatrimonialFormEstruturaFamiliar
                                                        values={values}
                                                        report={report}
                                                        clienteOuConjugeReport={HARDCODE.idFamiliarConjuge}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        )}
                                    </div>
                                )

                            : linhaReportImprimir.id === HARDCODE.carteiraInvestimentosChart ?
                            
                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.carteiraInvestimentos}
                                        conteudo={
                                            <CarteiraInvestimentosChart
                                                values={values}
                                                estudo={estudo}
                                                report={report}
                                                popup={false}
                                                simulacaoFinanceira={false}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )
                                
                            : linhaReportImprimir.id === HARDCODE.estudoFormTabelaEvolucaoValorResgate &&
                            exibirPagina(HARDCODE.estudoFormTabelaEvolucaoValorResgate) ?

                                (
                                    <div
                                        key={index}
                                    >
                                        {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras
                                        .filter(item => possuiCotacaoSeguroVidaApenasComparacaoPreco(values, item.id, false))
                                        ?.map( (cotacao, indCotacao) => (
                                            <div
                                                key={indCotacao}
                                            >
                                                {values.exibirResumoSeguroVidaCotacao && (
                                                    <EstudoReportPage
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={LABEL.resumoCotacao + ': ' + cotacao.descricao}
                                                        conteudo={
                                                            <EstudoFormResumoSeguroVidaCotacao
                                                                values={values}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras={cotacao}
                                                                utilizarApenasComparacaoPreco={false}
                                                                report={report}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                        espacoModoApresentacao={true}
                                                    />
                                                )}

                                                {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgate
                                                .filter(item => !item.utilizarApenasComparacaoPreco && item.seguradora === cotacao.id)
                                                ?.map( (item, ind) => (
                                                    
                                                    <div
                                                        key={ind}
                                                    >
                                                        {!values.exibirTabelaEvolucaoCS &&
                                                        !values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                            paginas(item.tabelaEvolucaoValorResgate, values.modoApresentacao ? 
                                                            HARDCODE.reportLinhasSemSaltoPagina : HARDCODE.reportLinhasSemGraficoSemTotaisComRodapeLetraMaior,
                                                            values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina :
                                                            HARDCODE.reportLinhasComGraficoGraficoMaior)?.map((itemPagina, indPagina) => (
                                                                <EstudoReportPage
                                                                    key={indPagina}
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    vars={vars}
                                                                    cabecalho={LABEL.protecaoSucessaoVitalicia/*tabelaEvolucaoValorResgate*/ + ': ' + item.nomeFamiliar}
                                                                    conteudo={
                                                                        <EstudoFormTabelaEvolucaoValorResgate
                                                                            values={values}
                                                                            estudo={estudo}
                                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                            report={report}
                                                                            indInicial={itemPagina.indInicial}
                                                                            indFinal={itemPagina.indFinal}
                                                                        />
                                                                    }
                                                                    pagina={obtemPagina(pagina)}
                                                                    espacoModoApresentacao={true}
                                                                />
                                                            ))
                                                        )}

                                                        {values.exibirTabelaEvolucaoCS && (
                                                            paginas(item.tabelaEvolucaoValorResgate, values.modoApresentacao ? 
                                                            HARDCODE.reportLinhasSemSaltoPagina :
                                                            HARDCODE.reportLinhasSemGraficoSemTotaisComRodapeLetraMaior)?.map((itemPagina, indPagina) => (
                                                                <EstudoReportPage
                                                                    key={indPagina}
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    vars={vars}
                                                                    cabecalho={LABEL.tabelaEvolucaoCS + ': ' + item.nomeFamiliar}
                                                                    conteudo={
                                                                        <EstudoFormTabelaEvolucaoCS
                                                                            values={values}
                                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                            report={report}
                                                                            indInicial={itemPagina.indInicial}
                                                                            indFinal={itemPagina.indFinal}
                                                                        />
                                                                    }
                                                                    pagina={obtemPagina(pagina)}
                                                                    espacoModoApresentacao={true}
                                                                />
                                                            ))
                                                        )}

                                                        {values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                            paginas(item.tabelaEvolucaoValorResgate, values.modoApresentacao ? 
                                                            HARDCODE.reportLinhasSemSaltoPagina :
                                                            HARDCODE.reportLinhasSemGraficoSemTotaisComRodapeLetraMaior)?.map((itemPagina, indPagina) => (
                                                                <EstudoReportPage
                                                                    key={indPagina}
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    vars={vars}
                                                                    cabecalho={LABEL.tabelaEvolucaoCancelamentoApolice + ': ' + item.nomeFamiliar}
                                                                    conteudo={
                                                                        <EstudoFormTabelaEvolucaoCancelamentoApolice
                                                                            values={values}
                                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                            report={report}
                                                                            indInicial={itemPagina.indInicial}
                                                                            indFinal={itemPagina.indFinal}
                                                                        />
                                                                    }
                                                                    pagina={obtemPagina(pagina)}
                                                                    espacoModoApresentacao={true}
                                                                />
                                                            ))
                                                        )}

                                                        {(values.exibirTabelaEvolucaoCS ||
                                                        values.exibirTabelaEvolucaoCancelamentoApolice) && (
                                                            <EstudoReportPage
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                                cabecalho={LABEL.protecaoSucessaoVitalicia/*tabelaEvolucaoValorResgate*/ + ': ' +
                                                                    item.nomeFamiliar
                                                                }
                                                                conteudo={
                                                                    <TabelaEvolucaoValorResgateChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={report}
                                                                        tabelaEvolucaoValorResgate={false}
                                                                    />
                                                                }
                                                                pagina={obtemPagina(pagina)}
                                                                espacoModoApresentacao={true}
                                                            />
                                                        )}

                                                        {values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira && 
                                                        !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                            <EstudoReportPage
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                                cabecalho={LABEL.analiseInvestimentoVersusSeguroVidaInteira + ': ' +
                                                                    item.nomeFamiliar
                                                                }
                                                                conteudo={
                                                                    <AnaliseInvestimentoVersusSeguroVidaInteiraChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={report}
                                                                    />
                                                                }
                                                                pagina={obtemPagina(pagina)}
                                                                espacoModoApresentacao={true}
                                                            />
                                                        )}
                                                        
                                                        {values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira && 
                                                        !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                            <EstudoReportPage
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                                cabecalho={LABEL.analiseInvestimentoVersusSeguroVidaInteira + ': ' +
                                                                    item.nomeFamiliar
                                                                }
                                                                conteudo={
                                                                    <AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={report}
                                                                    />
                                                                }
                                                                pagina={obtemPagina(pagina)}
                                                                espacoModoApresentacao={true}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormTabelaEvolucaoValorResgateComparacaoPreco &&
                            exibirPagina(HARDCODE.estudoFormTabelaEvolucaoValorResgateComparacaoPreco) ?

                                (
                                    <div
                                        key={index}
                                    >
                                        {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras
                                        .filter(item => possuiCotacaoSeguroVidaApenasComparacaoPreco(values, item.id, true))
                                        ?.map( (cotacao, indCotacao) => (
                                            <div
                                                key={indCotacao}
                                            >
                                                {values.exibirResumoSeguroVidaCotacao && (
                                                    <EstudoReportPage
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={LABEL.resumoCotacao + ': ' + cotacao.descricao +
                                                            ' (' + LABEL.comparacaoPreco + ')'
                                                        }
                                                        conteudo={
                                                            <EstudoFormResumoSeguroVidaCotacao
                                                                values={values}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras={cotacao}
                                                                utilizarApenasComparacaoPreco={true}
                                                                report={report}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                        espacoModoApresentacao={true}
                                                    />
                                                )}

                                               
                                                {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgate
                                                .filter(item => item.utilizarApenasComparacaoPreco && item.seguradora === cotacao.id)?.map( (item, ind) => (
                                                    <div
                                                        key={ind}
                                                    >
                                                        {!values.exibirTabelaEvolucaoCS &&
                                                        !values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                            paginas(item.tabelaEvolucaoValorResgate, values.modoApresentacao ? 
                                                            HARDCODE.reportLinhasSemSaltoPagina : HARDCODE.reportLinhasSemGraficoSemTotaisComRodapeLetraMaior,
                                                            values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina :
                                                            HARDCODE.reportLinhasComGraficoGraficoMaior)?.map((itemPagina, indPagina) => (
                                                                <EstudoReportPage
                                                                    key={indPagina}
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    vars={vars}
                                                                    cabecalho={LABEL.protecaoSucessaoVitalicia/*tabelaEvolucaoValorResgate*/ + ': ' + item.nomeFamiliar +
                                                                        ' (' + LABEL.comparacaoPreco + ')'
                                                                    }
                                                                    conteudo={
                                                                        <EstudoFormTabelaEvolucaoValorResgate
                                                                            values={values}
                                                                            estudo={estudo}
                                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                            report={report}
                                                                            indInicial={itemPagina.indInicial}
                                                                            indFinal={itemPagina.indFinal}
                                                                        />
                                                                    }
                                                                    pagina={obtemPagina(pagina)}
                                                                    espacoModoApresentacao={true}
                                                                />
                                                            ))
                                                        )}

                                                        {values.exibirTabelaEvolucaoCS &&
                                                            paginas(item.tabelaEvolucaoValorResgate, values.modoApresentacao ? 
                                                            HARDCODE.reportLinhasSemSaltoPagina :
                                                            HARDCODE.reportLinhasSemGraficoSemTotaisComRodapeLetraMaior)?.map((itemPagina, indPagina) => (
                                                                <EstudoReportPage
                                                                    key={indPagina}
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    vars={vars}
                                                                    cabecalho={LABEL.tabelaEvolucaoCS + ': ' + item.nomeFamiliar +
                                                                        ' (' + LABEL.comparacaoPreco + ')'
                                                                    }
                                                                    conteudo={
                                                                        <EstudoFormTabelaEvolucaoCS
                                                                            values={values}
                                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                            report={report}
                                                                            indInicial={itemPagina.indInicial}
                                                                            indFinal={itemPagina.indFinal}
                                                                        />
                                                                    }
                                                                    pagina={obtemPagina(pagina)}
                                                                    espacoModoApresentacao={true}
                                                                />
                                                        ))}

                                                        {values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                            paginas(item.tabelaEvolucaoValorResgate, values.modoApresentacao ? 
                                                            HARDCODE.reportLinhasSemSaltoPagina :
                                                            HARDCODE.reportLinhasSemGraficoSemTotaisComRodapeLetraMaior)?.map((itemPagina, indPagina) => (
                                                                <EstudoReportPage
                                                                    key={indPagina}
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    vars={vars}
                                                                    cabecalho={LABEL.tabelaEvolucaoCancelamentoApolice + ': ' +
                                                                        item.nomeFamiliar + ' (' + LABEL.comparacaoPreco + ')'
                                                                    }
                                                                    conteudo={
                                                                        <EstudoFormTabelaEvolucaoCancelamentoApolice
                                                                            values={values}
                                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                            report={report}
                                                                            indInicial={itemPagina.indInicial}
                                                                            indFinal={itemPagina.indFinal}
                                                                        />
                                                                    }
                                                                    pagina={obtemPagina(pagina)}
                                                                    espacoModoApresentacao={true}
                                                                />
                                                            ))
                                                        )}

                                                        {(values.exibirTabelaEvolucaoCS ||
                                                        values.exibirTabelaEvolucaoCancelamentoApolice) && (
                                                            <EstudoReportPage
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                                cabecalho={LABEL.protecaoSucessaoVitalicia/*tabelaEvolucaoValorResgate*/ + ': ' +
                                                                    item.nomeFamiliar + ' (' + LABEL.comparacaoPreco + ')'
                                                                }
                                                                conteudo={
                                                                    <TabelaEvolucaoValorResgateChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={report}
                                                                        tabelaEvolucaoValorResgate={false}
                                                                    />
                                                                }
                                                                pagina={obtemPagina(pagina)}
                                                                espacoModoApresentacao={true}
                                                            />
                                                        )}

                                                        {values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira && 
                                                        !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                            <EstudoReportPage
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                                cabecalho={LABEL.analiseInvestimentoVersusSeguroVidaInteira + ': ' +
                                                                    item.nomeFamiliar + ' (' + LABEL.comparacaoPreco + ')'
                                                                }
                                                                conteudo={
                                                                    <AnaliseInvestimentoVersusSeguroVidaInteiraChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={report}
                                                                    />
                                                                }
                                                                pagina={obtemPagina(pagina)}
                                                                espacoModoApresentacao={true}
                                                            />
                                                        )}
                                                        
                                                        {values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira && 
                                                        !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                            <EstudoReportPage
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                                cabecalho={LABEL.analiseInvestimentoVersusSeguroVidaInteira + ': ' +
                                                                    item.nomeFamiliar + ' (' + LABEL.comparacaoPreco + ')'
                                                                }
                                                                conteudo={
                                                                    <AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={report}
                                                                    />
                                                                }
                                                                pagina={obtemPagina(pagina)}
                                                                espacoModoApresentacao={true}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                )
                                
                            : linhaReportImprimir.id === HARDCODE.analisePatrimonialChart ||
                              linhaReportImprimir.id === HARDCODE.analisePatrimonialChartSemAlavancagem ?

                                (
                                    values.modoApresentacao
                                        ?
                                            <EstudoReportPage
                                                //key={ind}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.analisePatrimonial}
                                                conteudo={
                                                    <AnalisePatrimonialChart
                                                        values={values}
                                                        estudo={estudo}
                                                        report={report}
                                                        semAlavancagem={linhaReportImprimir.id === HARDCODE.analisePatrimonialChartSemAlavancagem}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        :
                                                <>
                                                    <EstudoReportPage
                                                        //key={ind}
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={LABEL.analisePatrimonial}
                                                        conteudo={
                                                            <AnalisePatrimonialChart
                                                                values={values}
                                                                estudo={estudo}
                                                                report={report}
                                                                semAlavancagem={linhaReportImprimir.id === HARDCODE.analisePatrimonialChartSemAlavancagem}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                    />

                                                    {(linhaReportImprimir.id === HARDCODE.analisePatrimonialChartSemAlavancagem ||
                                                    (linhaReportImprimir.id === HARDCODE.analisePatrimonialChart &&
                                                    !pesquisaList(values.reportImprimir, HARDCODE.analisePatrimonialChartSemAlavancagem).id)) && (
                                                        <>

                                                            {estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis.length +
                                                            estudo.current.patrimonioImobilizadoDetalhadoNegocios.length +
                                                            estudo.current.recursosFinanceirosDetalhado.length +
                                                            (
                                                                values.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao &&
                                                                estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado.length > 0
                                                                    ?
                                                                        estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado.length
                                                                    :
                                                                        0
                                                            ) <= 17
                                                                ?
                                                                    <EstudoReportPage
                                                                        //key={ind}
                                                                        variaveisGlobais={variaveisGlobais}
                                                                        values={values}
                                                                        vars={vars}
                                                                        cabecalho={LABEL.analisePatrimonial}
                                                                        conteudo={
                                                                            <GestaoPatrimonialFormResumoPatrimonial
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                report1Pagina={true}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                                                        }
                                                                        pagina={obtemPagina(pagina)}
                                                                    />
                                                                :
                                                                    <>
                                                                        {estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis.length > 0 && (
                                                                            paginas(estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis,
                                                                            values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                                                                <EstudoReportPage
                                                                                    key={ind}
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    vars={vars}
                                                                                    cabecalho={LABEL.patrimonioImobilizadoBensMoveisImoveis}
                                                                                    conteudo={
                                                                                        <EstudoFormGarantiasPatrimonioImobilizadoDetalhadoBensMoveisImoveis
                                                                                            values={values}
                                                                                            estudo={estudo}
                                                                                            report={report}
                                                                                            indInicial={item.indInicial}
                                                                                            indFinal={item.indFinal}
                                                                                            popup={false}
                                                                                        />
                                                                                    }
                                                                                    pagina={obtemPagina(pagina)}
                                                                                />
                                                                            ))
                                                                        )}

                                                                        {estudo.current.patrimonioImobilizadoDetalhadoNegocios.length > 0 && (
                                                                            paginas(estudo.current.patrimonioImobilizadoDetalhadoNegocios,
                                                                            values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                                                                <EstudoReportPage
                                                                                    key={ind}
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    vars={vars}
                                                                                    cabecalho={LABEL.patrimonioImobilizadoNegocios}
                                                                                    conteudo={
                                                                                        <EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios
                                                                                            values={values}
                                                                                            estudo={estudo}
                                                                                            report={report}
                                                                                            indInicial={item.indInicial}
                                                                                            indFinal={item.indFinal}
                                                                                            popup={false}
                                                                                        />
                                                                                    }
                                                                                    pagina={obtemPagina(pagina)}
                                                                                />
                                                                            ))
                                                                        )}

                                                                        {!values.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao &&
                                                                        estudo.current.recursosFinanceirosDetalhado.length > 0 && (
                                                                            paginas(estudo.current.recursosFinanceirosDetalhado,
                                                                            values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina :
                                                                            HARDCODE.reportLinhasSemGraficoRetrato)?.map((item, ind) => (
                                                                                <EstudoReportPage
                                                                                    key={ind}
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    vars={vars}
                                                                                    cabecalho={
                                                                                        LABEL.recursosFinanceiros.toUpperCase() + ': ' +
                                                                                            LABEL.instituicao + ' x ' +
                                                                                                LABEL.tipoRecursoFinanceiro
                                                                                    }
                                                                                    conteudo={
                                                                                        <EstudoFormGarantiasRecursosFinanceirosDetalhado
                                                                                            values={values}
                                                                                            estudo={estudo}
                                                                                            report={report}
                                                                                            indInicial={item.indInicial}
                                                                                            indFinal={item.indFinal}
                                                                                            popup={false}
                                                                                            recursosFinanceirosDetalhado={estudo.current.recursosFinanceirosDetalhado}
                                                                                            detalhadoTipoRecurso={false}
                                                                                        />
                                                                                    }
                                                                                    pagina={obtemPagina(pagina)}
                                                                                />
                                                                            ))
                                                                        )}

                                                                        {values.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao &&
                                                                        estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado.length > 0 && (
                                                                            paginas(estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado,
                                                                            values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina :
                                                                            HARDCODE.reportLinhasSemGraficoRetrato)?.map((item, ind) => (
                                                                                <EstudoReportPage
                                                                                    key={ind}
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    vars={vars}
                                                                                    cabecalho={
                                                                                        LABEL.recursosFinanceiros.toUpperCase() + ': ' +
                                                                                            LABEL.tipoRecursoFinanceiro + ' x ' +
                                                                                                LABEL.instituicao
                                                                                    }
                                                                                    conteudo={
                                                                                        <EstudoFormGarantiasRecursosFinanceirosDetalhado
                                                                                            values={values}
                                                                                            estudo={estudo}
                                                                                            report={report}
                                                                                            indInicial={item.indInicial}
                                                                                            indFinal={item.indFinal}
                                                                                            popup={false}
                                                                                            recursosFinanceirosDetalhado={estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado}
                                                                                            detalhadoTipoRecurso={true}
                                                                                        />
                                                                                    }
                                                                                    pagina={obtemPagina(pagina)}
                                                                                />
                                                                            ))
                                                                        )}
                                                                    </>
                                                            }

                                                            {/*paginas(
                                                                estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis.length >
                                                                estudo.current.patrimonioImobilizadoDetalhadoNegocios.length
                                                                    ?
                                                                        estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis.length >
                                                                        estudo.current.recursosFinanceirosDetalhado.length
                                                                            ?
                                                                                estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis
                                                                            :
                                                                                estudo.current.recursosFinanceirosDetalhado
                                                                    :
                                                                        estudo.current.patrimonioImobilizadoDetalhadoNegocios.length >
                                                                        estudo.current.recursosFinanceirosDetalhado.length
                                                                            ?
                                                                                estudo.current.patrimonioImobilizadoDetalhadoNegocios
                                                                            :
                                                                                estudo.current.recursosFinanceirosDetalhado,
                                                                parseInt(reportLinhasSemGrafico(values) / 1.5),
                                                                parseInt(reportLinhasComGrafico(values) / 1.5))
                                                                ?.map((item, ind) => (
                                                                    <EstudoReportPage
                                                                        key={ind}
                                                                        variaveisGlobais={variaveisGlobais}
                                                                        values={values}
                                                                        vars={vars}
                                                                        cabecalho={LABEL.analisePatrimonial}
                                                                        conteudo={
                                                                            <>
                                                                                {ind === 0 && (
                                                                                    <AnalisePatrimonialChart
                                                                                        values={values}
                                                                                        estudo={estudo}
                                                                                        report={report}
                                                                                    />
                                                                                )}

                                                                                <GestaoPatrimonialFormResumoPatrimonial
                                                                                    values={values}
                                                                                    estudo={estudo}
                                                                                    report={report}
                                                                                    indInicial={item.indInicial}
                                                                                    indFinal={item.indFinal}
                                                                                />
                                                                            </>
                                                                        }
                                                                        pagina={obtemPagina(pagina)}
                                                                    />
                                                                ))
                                                            */}
                                                        </>
                                                    )}
                                                </>
                                )

                            : linhaReportImprimir.id === HARDCODE.receitaAnualChart ?

                                (
                                    values.modoApresentacao
                                        ?
                                            <EstudoReportPage
                                                //key={ind}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.receitaAnualLongoTempo}
                                                conteudo={
                                                    <ReceitaAnualChart
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        estudo={estudo}
                                                        vars={vars}
                                                        report={report}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        :
                                            paginas(estudo.current.receitaMensalDetalhada,
                                            reportLinhasSemGrafico(values), reportLinhasComGrafico(values))?.map((item, ind) => (
                                                <EstudoReportPage
                                                    key={ind}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={LABEL.receitaAnualLongoTempo}
                                                    conteudo={
                                                        <>
                                                            {ind === 0 && (
                                                                <ReceitaAnualChart
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    estudo={estudo}
                                                                    vars={vars}
                                                                    report={report}
                                                                />
                                                            )}

                                                            <EstudoFormGarantiasReceitaMensalDetalhada
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                estudo={estudo}
                                                                vars={vars}
                                                                report={report}
                                                                indInicial={item.indInicial}
                                                                indFinal={item.indFinal}
                                                            />
                                                        </>
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />
                                            ))
                                )

                            : linhaReportImprimir.id === HARDCODE.analisesInformacoesReceitaAnualChart ?

                                (
                                    <EstudoReportPage
                                        //key={ind}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.aiFT + ': ' + LABEL.receitaAnualLongoTempo}
                                        conteudo={
                                            <AIFT
                                                aiFTOrigem={HARDCODE.analisesInformacoesReceitaAnualChart}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                estudo={estudo}
                                                vars={vars}
                                                report={true}
                                            />

                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )
                            
                            : linhaReportImprimir.id === HARDCODE.despesaAnualChart ?

                                (
                                    values.modoApresentacao
                                        ?
                                            <EstudoReportPage
                                                //key={ind}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.despesaAnualLongoTempo}
                                                conteudo={
                                                    <DespesaAnualChart
                                                        values={values}
                                                        estudo={estudo}
                                                        vars={vars}
                                                        report={report}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        :
                                            paginas(estudo.current.despesaMensalDetalhada,
                                            reportLinhasSemGrafico(values), reportLinhasComGrafico(values))?.map((item, ind) => (
                                                <EstudoReportPage
                                                    key={ind}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={LABEL.despesaAnualLongoTempo}
                                                    conteudo={
                                                        <>
                                                            {ind === 0 && (
                                                                <DespesaAnualChart
                                                                    values={values}
                                                                    estudo={estudo}
                                                                    vars={vars}
                                                                    report={report}
                                                                />
                                                            )}

                                                            <EstudoFormDespesasDespesaMensalDetalhada
                                                                values={values}
                                                                estudo={estudo}
                                                                vars={vars}
                                                                report={report}
                                                                indInicial={item.indInicial}
                                                                indFinal={item.indFinal}
                                                            />
                                                        </>
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />
                                            ))
                                )

                            : linhaReportImprimir.id === HARDCODE.balancoReceitaXDespesaAnualChart ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.balancoReceitaDespesaAnual}
                                        conteudo={
                                            <BalancoReceitaXDespesaAnualChart
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                estudo={estudo}
                                                vars={vars}
                                                report={report}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.analisesInformacoesBalancoReceitaXDespesaAnualChart ?

                                (
                                    <EstudoReportPage
                                        //key={ind}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.aiFT + ': ' + LABEL.balancoReceitaDespesaAnual}
                                        conteudo={
                                            <AIFT
                                                aiFTOrigem={HARDCODE.analisesInformacoesBalancoReceitaXDespesaAnualChart}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                estudo={estudo}
                                                vars={vars}
                                                report={true}
                                            />

                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.consumoReservaAposentadoriaChart ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.consumoReservaAposentadoria}
                                        conteudo={
                                            <ConsumoReservaAposentadoriaChart
                                                values={values}
                                                estudo={estudo}
                                                vars={vars}
                                                report={report}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.diagnosticoAposentadoriaChart ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.diagnosticoAposentadoria}
                                        conteudo={
                                            <EstudoReportDiagnosticoAposentadoriaChart
                                                values={values}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                                estudo={estudo}
                                                report={report}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                ) 

                            : linhaReportImprimir.id === HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraChart ?

                                (
                                    <div
                                        key={index}
                                    >
                                        {(estudo.current.necessidadeAposentadoria.length +
                                        estudo.current.aportePlanejadoAposentadoria.length < 8 &&
                                        values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato) ||
                                        values.modoApresentacao
                                            ?
                                                <EstudoReportPage
                                                    //key={index}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
                                                    conteudo={
                                                        <DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart
                                                            values={values}
                                                            estudo={estudo}
                                                            report={report}
                                                        />
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />
                                            :
                                                <>
                                                     <EstudoReportPage
                                                        //key={index}
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
                                                        conteudo={
                                                            <DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart
                                                                values={values}
                                                                estudo={estudo}
                                                                report={report}
                                                                naoExibirGrafico={true}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                    />

                                                    <EstudoReportPage
                                                        //key={index}
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
                                                        conteudo={
                                                            <DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart
                                                                values={values}
                                                                estudo={estudo}
                                                                report={report}
                                                                naoExibirCapacidadePoupanca={true}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                    />
                                                </>
                                        }

                                        {!values.naoExibirHipotesesRetornoRealAposentadoria &&
                                        calcValorPresenteDeficitSimulacaoMensalValorAporteMensalPreservarReservaAposentadoria(
                                        values) !== 0 && (
                                            <EstudoReportPage
                                                //key={index}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.hipotesesRetornoReal + ": " + LABEL.aposentadoria}
                                                conteudo={
                                                    <HipotesesRetornoRealChart
                                                        values={values}
                                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                                        estudo={estudo}
                                                        report={report}
                                                        jsonConfiguracao={vars.jsonConfiguracao}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        )}
                                    </div>
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormEvolucaoReservaFinanceiraEstudo ?

                                (
                                    paginas(estudo.current.evolucaoReservaFinanceiraEstudo,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina :
                                    HARDCODE.reportLinhasSemGraficoSemTotaisComRodape)?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.evolucaoReservaFinanceira}
                                            conteudo={
                                                <EstudoFormEvolucaoReservaFinanceiraEstudo
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    popup={false}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormProjetoVidaSonhoTracarMeta &&
                            exibirPagina(HARDCODE.estudoFormProjetoVidaSonhoTracarMeta) ?

                                (
                                    paginas(estudo.current.projetoVidaSonhoTracarMeta,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : values.exibirHipotesesRetornoRealProjetoVidaSonho ? 2 : null)?.map(
                                    (item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.projetoVidaSonhoTracarMeta}
                                            conteudo={
                                                <EstudoReportProjetoVidaSonhoTracarMeta
                                                    values={values}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    estudo={estudo}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )
                            
                            : linhaReportImprimir.id === HARDCODE.previdenciaPrivadaFormPrevidenciaPrivada &&
                            exibirPagina(HARDCODE.previdenciaPrivadaFormPrevidenciaPrivada) ?

                                (
                                    <div
                                        key={index}
                                    >
                                         {values.modoApresentacao
                                            ?
                                                <EstudoReportPage
                                                    //key={index}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={LABEL.analiseBeneficiosPrevidenciaPrivada}
                                                    conteudo={
                                                        <PrevidenciaPrivadaFormPrevidenciaPrivada
                                                            values={values}
                                                            handleChange={handleChange}
                                                            handleSubmit={handleSubmit}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                            estudo={estudo}
                                                            report={report}
                                                        />
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />
                                            :
                                                <>
                                                    <EstudoReportPage
                                                        //key={index}
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={LABEL.analiseBeneficiosPrevidenciaPrivada}
                                                        conteudo={
                                                            <PrevidenciaPrivadaFormPrevidenciaPrivada
                                                                values={values}
                                                                handleChange={handleChange}
                                                                handleSubmit={handleSubmit}
                                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                                estudo={estudo}
                                                                report={report}
                                                                pagina={1}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                    />

                                                    {values.objPrevidenciaPrivada.contribuiINSSRPPSOuAposentador === 'S' && (
                                                        <EstudoReportPage
                                                            //key={'segundaPagina' + index}
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            vars={vars}
                                                            cabecalho={LABEL.analiseBeneficiosPrevidenciaPrivada}
                                                            conteudo={
                                                                <PrevidenciaPrivadaFormPrevidenciaPrivada
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    handleSubmit={handleSubmit}
                                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                                    estudo={estudo}
                                                                    report={report}
                                                                    pagina={2}
                                                                />
                                                            }
                                                            pagina={obtemPagina(pagina)}
                                                        />
                                                    )}

                                                    {values.objPrevidenciaPrivada.simulacao?.map((item, ind) => (
                                                        <EstudoReportPage
                                                            key={ind}
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            vars={vars}
                                                            cabecalho={LABEL.analiseBeneficiosPrevidenciaPrivada}
                                                            conteudo={
                                                                <PrevidenciaPrivadaFormPrevidenciaPrivada
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    handleSubmit={handleSubmit}
                                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                                    estudo={estudo}
                                                                    report={report}
                                                                    indReport={ind}
                                                                    pagina={3}
                                                                />
                                                            }
                                                            pagina={obtemPagina(pagina)}
                                                        />
                                                    ))}
                                                </>
                                        }
                                    </div>
                                )

                            : linhaReportImprimir.id === HARDCODE.consorcioFormSimulacaoItemReport &&
                                exibirPagina(HARDCODE.consorcioFormSimulacaoItemReport) ?

                                values.objConsorcio.simulacao?.map((item, ind) => (
                                    !item.naoExibirRelatorio && (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.simulacaoConsorcio}
                                            conteudo={
                                                <ConsorcioFormSimulacaoItemReport
                                                    values={values}
                                                    item={item}
                                                    report={true}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    )
                                ))

                            /*
                            : linhaReportImprimir.id === HARDCODE.consorcioFormSimulacao &&
                                exibirPagina(HARDCODE.consorcioFormSimulacao) ?

                                values.modoApresentacao
                                    ?
                                        <EstudoReportPage
                                            //key={index}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.simulacaoConsorcio}
                                            conteudo={
                                                <ConsorcioFormSimulacao
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleChange={handleChange}
                                                    handleSubmit={handleSubmit}
                                                    setFieldValue=?
                                                    linhaTipoLicenca=?
                                                    report={true}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    :
                                        values.objConsorcio.simulacao?.map((item, ind) => (
                                            <>
                                                <EstudoReportPage
                                                    key={ind}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={LABEL.simulacaoConsorcio}
                                                    conteudo={
                                                        <ConsorcioFormSimulacao
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleChange={handleChange}
                                                            handleSubmit={handleSubmit}
                                                            setFieldValue=?
                                                            linhaTipoLicenca=?
                                                            report={true}
                                                            indAtual={ind}
                                                            pagina={1}
                                                        />
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />

                                                <EstudoReportPage
                                                    key={ind}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={LABEL.simulacaoConsorcio}
                                                    conteudo={
                                                        <ConsorcioFormSimulacao
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleChange={handleChange}
                                                            handleSubmit={handleSubmit}
                                                            setFieldValue=?
                                                            linhaTipoLicenca=>
                                                            report={true}
                                                            indAtual={ind}
                                                            pagina={2}
                                                        />
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />
                                            </>
                                        ))
                            */

                            : linhaReportImprimir.id === HARDCODE.estudoFormComparacaoFinanciamentos &&
                                exibirPagina(HARDCODE.estudoFormComparacaoFinanciamentos) ?

                                (
                                    paginas(estudo.current.fluxoCaixaMensalEconomiaPerdaResumo,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : HARDCODE.reportLinhasSemGraficoSemTotais,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : HARDCODE.reportLinhasComGraficoGraficoMaiorTituloTabela, true)?.map((item, ind) => ( // mudança da fonte: 25 
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.analiseFinanciamentoSugerido}
                                            conteudo={
                                                <ComparacaoFinanciamentosChart
                                                    values={values}
                                                    estudo={estudo}
                                                    report={true}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormComparacaoFinanciamentosDetalhe &&
                                exibirPagina(HARDCODE.estudoFormComparacaoFinanciamentosDetalhe) ?

                                (
                                    paginas(estudo.current.fluxoCaixaMensalEconomiaPerdaDetalhe,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina :
                                    HARDCODE.reportLinhasSemGraficoSemTotais)?.map((item, ind) => ( // mudança da fonte: 25 
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.analiseFinanciamentoSugerido + ': ' + LABEL.parcelasMesAMes}
                                            conteudo={
                                                <EstudoFormComparacaoFinanciamentoTabelaDetalhe
                                                    values={values}
                                                    estudo={estudo}
                                                    report={true}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )
                                
                            : linhaReportImprimir.id === HARDCODE.estudoFormProtecaoSugerida ?

                                (
                                    <div
                                        key={index}
                                    >
                                        <EstudoReportPage
                                            //key={index}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.protecaoSugerida}
                                            conteudo={
                                                <ProtecaoSugerida
                                                    values={values}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    estudo={estudo}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />

                                        {dadosCompletosConjuge(values) &&
                                        !((
                                            values.protecaoSugeridaCliente && values.protecaoSugeridaConjuge &&
                                            values.protecaoSugeridaCliente.length + values.protecaoSugeridaConjuge.length < 10
                                        ) ||
                                        //values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ||
                                        values.modoApresentacao) && (
                                            <EstudoReportPage
                                                //key={'conjuge' + index}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.protecaoSugerida}
                                                conteudo={
                                                    <EstudoFormProtecaoSugerida
                                                        variaveisGlobais={variaveisGlobais} 
                                                        values={values}
                                                        estudo={estudo}
                                                        vars={vars}
                                                        titulo={tituloConjuge(values)}
                                                        idClienteConjuge={HARDCODE.idFamiliarConjuge}
                                                        report={report}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        )}
                                    </div>
                                )

                            : linhaReportImprimir.id === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente ?

                                (
                                    <EstudoReportPage
                                        //key={ind}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.aiFT + ': ' + LABEL.protecaoSugerida + ' ' + tituloCliente(values)}
                                        conteudo={
                                            <AIFT
                                                aiFTOrigem={HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                estudo={estudo}
                                                vars={vars}
                                                report={true}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )
                            
                            : linhaReportImprimir.id === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaConjuge ?

                                (
                                    <EstudoReportPage
                                        //key={ind}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.aiFT + ': ' + LABEL.protecaoSugerida + ' ' + tituloConjuge(values)}
                                        conteudo={
                                            <AIFT
                                                aiFTOrigem={HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaConjuge}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                estudo={estudo}
                                                vars={vars}
                                                report={true}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.informacoesTipoRegimeBens ?

                                (
                                    jsonPaginaPaginaAdicional?.map((item, ind) => {
                                        
                                        const indexItemPagina = 0
                                        const linhaItemPagina =
                                            item.itemPagina && item.itemPagina.length > 0
                                                ?
                                                    item.itemPagina[indexItemPagina]
                                                :
                                                    ''
                                        const linhaContasInvestimentos = []

                                        return linhaItemPagina && item.tipoRegimeBens === values.tipoRegimeBens ?
                                            
                                            <EstudoReportPage
                                                key={ind}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={item.tituloPagina}
                                                paginaInteira={item.paginaInteira}
                                                conteudo={
                                                    <PaginaAdicionalTextoImagem
                                                        linhaReportImprimir={linhaReportImprimir}
                                                        indexItemPagina={indexItemPagina}
                                                        linhaItemPagina={linhaItemPagina}
                                                        linhaContasInvestimentos={linhaContasInvestimentos}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        :
                                            ''
                                    })
                                )
                                
                            : linhaReportImprimir.id === HARDCODE.informacoesUfsInventario ?

                                (
                                    values.ufsInventario?.map((linhaUfsInventario, indUfsInventario) => (

                                        jsonPaginaPaginaAdicional?.map((item, ind) => {
                                            
                                            const indexItemPagina = 0
                                            const linhaItemPagina =
                                                item.itemPagina && item.itemPagina.length > 0
                                                    ?
                                                        item.itemPagina[indexItemPagina]
                                                    :
                                                        ''
                                            const linhaContasInvestimentos = []

                                            return linhaItemPagina && item.ufInventario === linhaUfsInventario.id ?
                                                
                                                <EstudoReportPage
                                                    key={ind}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={item.tituloPagina}
                                                    paginaInteira={item.paginaInteira}
                                                    conteudo={
                                                        <PaginaAdicionalTextoImagem
                                                            linhaReportImprimir={linhaReportImprimir}
                                                            indexItemPagina={indexItemPagina}
                                                            linhaItemPagina={linhaItemPagina}
                                                            linhaContasInvestimentos={linhaContasInvestimentos}
                                                        />
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />
                                            :
                                                ''
                                        })
                                    ))
                                )
                                
                            : linhaReportImprimir.id === HARDCODE.estudoFormSucessaoVitalicia ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.sucessaoVitalicia}
                                        conteudo={
                                            <EstudoFormSucessaoVitalicia
                                                values={values}
                                                estudo={estudo}
                                                report={report}
                                                //jsonConfiguracao={vars.jsonConfiguracao}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormComposicaoInventario ?

                                (
                                    paginas(estudo.current.inventario, values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.composicaoInventario}
                                            conteudo={
                                                <EstudoFormComposicaoInventario
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.projecaoSucessaoVitaliciaChart ?
                            
                                /*(
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.projecaoSucessaoVitalicia}
                                        conteudo={
                                            <ProjecaoSucessaoVitaliciaChart
                                                values={values}
                                                estudo={estudo}
                                                report={report}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )*/
                                (
                                    values.modoApresentacao
                                        ?
                                            <EstudoReportPage
                                                //key={ind}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.projecaoSucessaoVitalicia}
                                                conteudo={
                                                    <ProjecaoSucessaoVitaliciaChart
                                                        values={values}
                                                        estudo={estudo}
                                                        report={report}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        :
                                            paginas(estudo.current.tabelaProjecaoSucessaoVitalicia,
                                            HARDCODE.reportLinhasSemGraficoSemTotaisComRodape, reportLinhasComGrafico(values))?.map((item, ind) => (
                                                <EstudoReportPage
                                                    key={ind}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={LABEL.projecaoSucessaoVitalicia}
                                                    conteudo={
                                                        <>
                                                            {ind === 0 && (
                                                                <ProjecaoSucessaoVitaliciaChart
                                                                    values={values}
                                                                    estudo={estudo}
                                                                    report={report}
                                                                />
                                                            )}

                                                            <EstudoFormProjecaoSucessaoVitalicia
                                                                values={values}
                                                                estudo={estudo}
                                                                report={report}
                                                                indInicial={item.indInicial}
                                                                indFinal={item.indFinal}
                                                            />
                                                        </>
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />
                                            ))
                                )

                            : linhaReportImprimir.id === HARDCODE.despesasAcumuladasChart ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.despesasAcumuladasLongoTempo}
                                        conteudo={
                                            <EstudoReportDespesasAcumuladas
                                                values={values}
                                                handleChange={handleChange}
                                                estudo={estudo}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoReportResumoNecessidadeProtecao ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.necessidadeProtecao}
                                        conteudo={
                                            <EstudoReportResumoNecessidadeProtecao
                                                values={values}
                                                estudo={estudo}
                                                report={report}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormDespesasDiaDiaDespesasVitalicias ?

                                (
                                    paginas(estudo.current.diaDiaDespesasVitalicias,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.diaDiaDespesasVitalicias}
                                            conteudo={
                                                <EstudoFormDespesasDiaDiaDespesasVitalicias
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormDespesasEducacao ?

                                (
                                    paginas(estudo.current.educacao,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.educacao}
                                            conteudo={
                                                <EstudoFormDespesasEducacao
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormDespesasFinanciamento ?

                                (
                                    paginas(estudo.current.financiamento,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.financiamento}
                                            conteudo={
                                                <EstudoFormDespesasFinanciamento
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormDespesasDiaDiaDespesasTemporarias ?

                                (
                                    paginas(estudo.current.diaDiaDespesasTemporarias,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.diaDiaDespesasTemporarias}
                                            conteudo={
                                                <EstudoFormDespesasDiaDiaDespesasTemporarias
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormProjetoVidaSonho ?

                                (
                                    paginas(estudo.current.projetoVidaSonho,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.projetoVidaSonho}
                                            conteudo={
                                                <EstudoFormProjetoVidaSonho
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormGarantiasPatrimonioImobilizado ?

                                (
                                    paginas(estudo.current.patrimonioImobilizado,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.patrimonioImobilizado}
                                            conteudo={
                                                <EstudoFormGarantiasPatrimonioImobilizado
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )
                                
                            : linhaReportImprimir.id === HARDCODE.estudoFormGarantiasReceitaMensal ?

                                (
                                    paginas(estudo.current.receitaMensal,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.receitaMensal}
                                            conteudo={
                                                <EstudoFormGarantiasReceitaMensal
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormGarantiasRecursosFinanceiros ?

                                (
                                    paginas(estudo.current.recursosFinanceiros,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.recursosFinanceiros}
                                            conteudo={
                                                <EstudoFormGarantiasRecursosFinanceiros
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormSeguroVida ?

                                (
                                    paginas(estudo.current.seguroVida,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.seguroVida}
                                            conteudo={
                                                <EstudoFormSeguroVida
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart ?

                                <EstudoReportPage
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                    cabecalho={LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
                                    conteudo={
                                        <DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            estudo={estudo}
                                            report={true}
                                            popup={false}
                                        />
                                    }
                                    pagina={obtemPagina(pagina)}
                                />

                            : linhaReportImprimir.id === HARDCODE.simulacaoFinanceiraFormEvolucaoReservaFinanceira ?

                                (
                                    paginas(estudo.current.evolucaoReservaFinanceiraReport,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina :
                                    HARDCODE.reportLinhasSemGraficoSemTotaisComRodape)?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.evolucaoReservaFinanceira}
                                            conteudo={
                                                <SimulacaoFinanceiraFormEvolucaoReservaFinanceira
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    popup={false}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.mapaFinanceiroFormGrafico ?

                                (
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.mapaFinanceiro}
                                        conteudo={
                                            <MapaFinanceiroFormGrafico
                                                values={values}
                                                report={report}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormComparacaoCenariosGrafico ?
                            
                                (
                                    paginas(calculaMaiorPeriodoGraficoIdadesCenarios(values),
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : HARDCODE.reportLinhasSemGraficoSemTotais,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : HARDCODE.reportLinhasComGraficoMenor)?.map((item, ind) => ( // mudança da fonte: 25 
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.comparacaoCenarios}
                                            conteudo={
                                                <ComparacaoCenariosEstudosChart
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    estudo={estudo}
                                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    jsonPagina={vars.jsonPagina}
                                                    jsonUsuario={vars.jsonUsuario}
                                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                    report={report}
                                                    comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                    simulacaoFinanceira={false}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormComparacaoCenarios ?

                                (
                                    <div
                                        key={index}
                                    >
                                        <EstudoFormComparacaoCenariosEstudos
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                            estudo={estudo}
                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                            jsonConfiguracao={vars.jsonConfiguracao}
                                            jsonPagina={vars.jsonPagina}
                                            jsonUsuario={vars.jsonUsuario}
                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                            report={report}
                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                            simulacaoFinanceira={false}
                                            soCalculo={true}
                                        />
                                        <EstudoReportPage
                                            //key={index}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.comparacaoCenarios}
                                            conteudo={
                                                <EstudoFormComparacaoCenariosEstudos
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    estudo={estudo}
                                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    jsonPagina={vars.jsonPagina}
                                                    jsonUsuario={vars.jsonUsuario}
                                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                    report={report}
                                                    comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                    simulacaoFinanceira={false}
                                                    parte1={
                                                        values.comparacaoCenariosEstudosItem && values.comparacaoCenariosEstudosItem.length > HARDCODE.comparacaoCenariosEstudosItemMaximoItem1Pagina
                                                            ?
                                                                true
                                                            :
                                                                false
                                                    }
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                        {values.comparacaoCenariosEstudosItem && values.comparacaoCenariosEstudosItem.length > HARDCODE.comparacaoCenariosEstudosItemMaximoItem1Pagina
                                            ?
                                                <EstudoReportPage
                                                    //key={index}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={LABEL.comparacaoCenarios}
                                                    conteudo={
                                                        <EstudoFormComparacaoCenariosEstudos
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                            estudo={estudo}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            jsonPagina={vars.jsonPagina}
                                                            jsonUsuario={vars.jsonUsuario}
                                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                            report={report}
                                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                            simulacaoFinanceira={false}
                                                            parte2={true}
                                                        />
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />
                                            :
                                                ''
                                        }
                                    </div>
                                )
                            
                            : linhaReportImprimir.id === HARDCODE.estudoFormComparacaoEstudosGrafico &&
                            exibirPagina(HARDCODE.estudoFormComparacaoEstudosGrafico) ?

                                (
                                    paginas(calculaMaiorPeriodoGraficoIdadesEstudos(values),
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : HARDCODE.reportLinhasSemGraficoSemTotais,
                                    values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : HARDCODE.reportLinhasComGraficoMenor)?.map((item, ind) => ( // mudança da fonte: 25
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.comparacaoEstudos}
                                            conteudo={
                                                <ComparacaoCenariosEstudosChart
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    estudo={estudo}
                                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    jsonPagina={vars.jsonPagina}
                                                    jsonUsuario={vars.jsonUsuario}
                                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                    report={report}
                                                    comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                                    simulacaoFinanceira={false}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormComparacaoEstudos &&
                            exibirPagina(HARDCODE.estudoFormComparacaoEstudos) ?

                                (
                                    <div
                                        key={index}
                                    >
                                        <EstudoFormComparacaoCenariosEstudos
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                            estudo={estudo}
                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                            jsonConfiguracao={vars.jsonConfiguracao}
                                            jsonPagina={vars.jsonPagina}
                                            jsonUsuario={vars.jsonUsuario}
                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                            report={report}
                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                            simulacaoFinanceira={false}
                                            soCalculo={true}
                                        />
                                        <EstudoReportPage
                                            //key={index}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.comparacaoEstudos}
                                            conteudo={
                                                <EstudoFormComparacaoCenariosEstudos
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    estudo={estudo}
                                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    jsonPagina={vars.jsonPagina}
                                                    jsonUsuario={vars.jsonUsuario}
                                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                    report={report}
                                                    comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                                    simulacaoFinanceira={false}
                                                    parte1={
                                                        values.comparacaoCenariosEstudosItem && values.comparacaoCenariosEstudosItem.length > HARDCODE.comparacaoCenariosEstudosItemMaximoItem1Pagina
                                                            ?
                                                                true
                                                            :
                                                                false
                                                    }
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                        {values.comparacaoCenariosEstudosItem && values.comparacaoCenariosEstudosItem.length > HARDCODE.comparacaoCenariosEstudosItemMaximoItem1Pagina
                                            ?
                                                <EstudoReportPage
                                                    //key={index}
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    vars={vars}
                                                    cabecalho={LABEL.comparacaoEstudos}
                                                    conteudo={
                                                        <EstudoFormComparacaoCenariosEstudos
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                            estudo={estudo}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            jsonPagina={vars.jsonPagina}
                                                            jsonUsuario={vars.jsonUsuario}
                                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                            report={report}
                                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                                            simulacaoFinanceira={false}
                                                            parte2={true}
                                                        />
                                                    }
                                                    pagina={obtemPagina(pagina)}
                                                />
                                            :
                                                ''
                                        }
                                    </div>
                                )

                            : linhaReportImprimir.id === HARDCODE.estudoFormConsideracoesFinais &&
                            exibirPagina(HARDCODE.estudoFormConsideracoesFinais) ?

                                (
                                    values.consideracaoFinal?.map((item, ind) => (
                                        item.richText && item.richText !== HARDCODE.richTextEditorVazio && (
                                            <EstudoReportPage
                                                key={ind}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={nvl(item.tituloPagina, linhaFormList.labelTabClienteFormListConsideracoesFinais)}
                                                conteudo={
                                                    <EstudoFormConsideracoesFinais
                                                        values={values}
                                                        linhaFormList={linhaFormList}
                                                        report={report}
                                                        indPagina={ind}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        )
                                    ))
                                )
                                
                            : linhaReportImprimir.id === HARDCODE.estudoReportDisclaimer &&
                            exibirPagina(HARDCODE.estudoReportDisclaimer) ?

                                (
                                    <EstudoReportPage
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.disclaimer}
                                        conteudo={
                                            <EstudoReportDisclaimer
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )
                            
                            : linhaReportImprimir.id.indexOf(HARDCODE.estudoFormPagina) !== -1 &&
                              exibirPagina(linhaReportImprimir.id) ?

                                calcularPaginas(values, jsonPaginaPaginaAdicional, linhaReportImprimir.id)?.map( (linhaContasInvestimentos) => (
                                    
                                    <EstudoReportPage
                                        key={index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={
                                            pesquisaList(jsonPaginaPaginaAdicional, 
                                                linhaReportImprimir.id.substring(HARDCODE.estudoFormPagina.length)).tituloPagina
                                        }
                                        paginaInteira={
                                            pesquisaList(jsonPaginaPaginaAdicional, 
                                                linhaReportImprimir.id.substring(HARDCODE.estudoFormPagina.length)).paginaInteira
                                        }
                                        conteudo={
                                            <>
                                                {pesquisaList(jsonPaginaPaginaAdicional,
                                                    linhaReportImprimir.id.substring(
                                                        HARDCODE.estudoFormPagina.length)).itemPagina?.map(
                                                            (linhaItemPagina, indexItemPagina) => {

                                                                return (
                                                                    <div
                                                                        key={indexItemPagina}
                                                                        className={
                                                                            'mt-' + linhaItemPagina.margemTop + ' ml-' + linhaItemPagina.margemLeft
                                                                        }
                                                                    >
                                                                        {(linhaItemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaTextoImagem ||
                                                                        linhaItemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaTextoImagemVariavel ||
                                                                        linhaItemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaTextoImagemContasInvestimentos) ?

                                                                            <PaginaAdicionalTextoImagem
                                                                                linhaReportImprimir={linhaReportImprimir}
                                                                                indexItemPagina={indexItemPagina}
                                                                                linhaItemPagina={linhaItemPagina}
                                                                                linhaContasInvestimentos={linhaContasInvestimentos}
                                                                            />

                                                                        : (linhaItemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaHTML ||
                                                                        linhaItemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaHTMLVariavel ||
                                                                        linhaItemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaHTMLContasInvestimentos) ?

                                                                            <>
                                                                                {values.modoApresentacao
                                                                                    ?
                                                                                        <GridContainer>
                                                                                            <GridItem11>
                                                                                                <div
                                                                                                    dangerouslySetInnerHTML={
                                                                                                        { __html: substituirVariaveis(linhaItemPagina.tipoItemPagina, linhaItemPagina.html, values, estudo, linhaContasInvestimentos)}
                                                                                                    }
                                                                                                />
                                                                                            </GridItem11>
                                                                                        </GridContainer>
                                                                                    :
                                                                                        <div
                                                                                            dangerouslySetInnerHTML={
                                                                                                { __html: substituirVariaveis(linhaItemPagina.tipoItemPagina, linhaItemPagina.html, values, estudo, linhaContasInvestimentos)}
                                                                                            }
                                                                                        />
                                                                                }
                                                                            </>

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoReportConferenciaDados ?
                                                                        
                                                                            <EstudoReportConferenciaDados
                                                                                values={values}
                                                                                report={report}
                                                                                vars={vars}
                                                                                somenteClienteConjugeFamiliares={false}
                                                                                somenteClienteConjugeFamiliaresTaxas={false}
                                                                                incluirObjetivos={false}
                                                                            />

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoReportConferenciaDadosClienteConjugeFamiliares ?
                                                                        
                                                                            <EstudoReportConferenciaDados
                                                                                values={values}
                                                                                report={report}
                                                                                vars={vars}
                                                                                somenteClienteConjugeFamiliares={true}
                                                                                somenteClienteConjugeFamiliaresTaxas={false}
                                                                                incluirObjetivos={false}
                                                                            />
                                                                        
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoReportConferenciaDadosClienteConjugeFamiliaresObjetivos ?
                                                                        
                                                                            <EstudoReportConferenciaDados
                                                                                values={values}
                                                                                report={report}
                                                                                vars={vars}
                                                                                somenteClienteConjugeFamiliares={true}
                                                                                somenteClienteConjugeFamiliaresTaxas={false}
                                                                                incluirObjetivos={true}
                                                                            />
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoReportConferenciaDadosClienteConjugeFamiliaresTaxas ?
                                                                        
                                                                            <EstudoReportConferenciaDados
                                                                                values={values}
                                                                                report={report}
                                                                                vars={vars}
                                                                                somenteClienteConjugeFamiliares={false}
                                                                                somenteClienteConjugeFamiliaresTaxas={true}
                                                                                incluirObjetivos={false}
                                                                            />

                                                                        : linhaItemPagina.graficoTabela ===
                                                                            HARDCODE.estudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo &&
                                                                                exibirPagina(HARDCODE.estudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo) ?
                                                                        
                                                                            <EstudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                            />

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.carteiraInvestimentosChart ?

                                                                            <CarteiraInvestimentosChart
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                popup={false}
                                                                                simulacaoFinanceira={false}
                                                                            />

                                                                        : linhaReportImprimir.id === HARDCODE.analisePatrimonialChart ||
                                                                          linhaReportImprimir.id === HARDCODE.analisePatrimonialChartSemAlavancagem ?
                                                                            
                                                                            <>
                                                                                <AnalisePatrimonialChart
                                                                                    values={values}
                                                                                    estudo={estudo}
                                                                                    report={report}
                                                                                    semAlavancagem={linhaReportImprimir.id === HARDCODE.analisePatrimonialChartSemAlavancagem}
                                                                                />
                                        
                                                                                {/*!values.modoApresentacao && (
                                                                                    <GestaoPatrimonialFormResumoPatrimonial
                                                                                        values={values}
                                                                                        estudo={estudo}
                                                                                        report={report}
                                                                                    />
                                                                                )*/}
                                                                            </>
                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.receitaAnualChart ?

                                                                            <>
                                                                                <ReceitaAnualChart
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    estudo={estudo}
                                                                                    vars={vars}
                                                                                    report={report}
                                                                                />

                                                                                {!values.modoApresentacao && (
                                                                                    <EstudoFormGarantiasReceitaMensalDetalhada
                                                                                        variaveisGlobais={variaveisGlobais}
                                                                                        values={values}
                                                                                        estudo={estudo}
                                                                                        vars={vars}
                                                                                        report={report}
                                                                                    />
                                                                                )}
                                                                            </>

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.analisesInformacoesReceitaAnualChart ?

                                                                            <AIFT
                                                                                aiFTOrigem={HARDCODE.analisesInformacoesReceitaAnualChart}
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                vars={vars}
                                                                                report={true}
                                                                            />

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.despesaAnualChart ?

                                                                            <>
                                                                                <DespesaAnualChart
                                                                                    values={values}
                                                                                    estudo={estudo}
                                                                                    vars={vars}
                                                                                    report={report}
                                                                                />
                                                                            
                                                                                {!values.modoApresentacao && (
                                                                                    <EstudoFormDespesasDespesaMensalDetalhada
                                                                                        values={values}
                                                                                        estudo={estudo}
                                                                                        vars={vars}
                                                                                        report={report}
                                                                                    />
                                                                                )}
                                                                            </>
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.balancoReceitaXDespesaAnualChart ?

                                                                            <BalancoReceitaXDespesaAnualChart
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                vars={vars}
                                                                                report={report}
                                                                            />

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.analisesInformacoesBalancoReceitaXDespesaAnualChart ?

                                                                            <AIFT
                                                                                aiFTOrigem={HARDCODE.analisesInformacoesBalancoReceitaXDespesaAnualChart}
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                vars={vars}
                                                                                report={true}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.consumoReservaAposentadoriaChart ?

                                                                            <ConsumoReservaAposentadoriaChart
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                vars={vars}
                                                                                report={report}
                                                                            />

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.diagnosticoAposentadoriaChart ?

                                                                            <EstudoReportDiagnosticoAposentadoriaChart
                                                                                values={values}
                                                                                handleChange={handleChange}
                                                                                setFieldValue={setFieldValue}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela ===
                                                                            HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraChart ?
                                                                            
                                                                            <DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart
                                                                                values={values}
                                                                            estudo={estudo}
                                                                            report={report}
                                                                        />

                                                                        : linhaItemPagina.graficoTabela ===
                                                                            HARDCODE.estudoFormProjetoVidaSonhoTracarMeta ?
                                                                                                            
                                                                            <EstudoReportProjetoVidaSonhoTracarMeta
                                                                                values={values}
                                                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                estudo={estudo}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormProtecaoSugerida ?
                                                                                        
                                                                            <ProtecaoSugerida
                                                                                values={values}
                                                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                estudo={estudo}
                                                                            />

                                                                        : linhaReportImprimir.id === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente ?

                                                                            <AIFT
                                                                                aiFTOrigem={HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente}
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                vars={vars}
                                                                                report={true}
                                                                            />
                            
                                                                        : linhaReportImprimir.id === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaConjuge ?

                                                                            <AIFT
                                                                                aiFTOrigem={HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaConjuge}
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                vars={vars}
                                                                                report={true}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormSucessaoVitalicia ?

                                                                            <EstudoFormSucessaoVitalicia
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                //jsonConfiguracao={vars.jsonConfiguracao}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormComposicaoInventario ?
                                                                                            
                                                                            <EstudoFormComposicaoInventario
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.projecaoSucessaoVitaliciaChart ?
                                                                            
                                                                            <ProjecaoSucessaoVitaliciaChart
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                            />

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.despesasAcumuladasChart ?
                                                                                        
                                                                            <EstudoReportDespesasAcumuladas
                                                                                values={values}
                                                                                handleChange={handleChange}
                                                                                estudo={estudo}
                                                                            />
                                                                        
                                                                        : linhaItemPagina.graficoTabela ===
                                                                            HARDCODE.estudoReportResumoNecessidadeProtecao ?
                                                                                        
                                                                            <EstudoReportResumoNecessidadeProtecao
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela ===
                                                                            HARDCODE.estudoFormDespesasDiaDiaDespesasVitalicias ?
                                                                                            
                                                                            <EstudoFormDespesasDiaDiaDespesasVitalicias
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormDespesasEducacao ?
                                                                                            
                                                                            <EstudoFormDespesasEducacao
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormDespesasFinanciamento ?
                                                                                            
                                                                            <EstudoFormDespesasFinanciamento
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela ===
                                                                            HARDCODE.estudoFormDespesasDiaDiaDespesasTemporarias ?
                                                                                            
                                                                            <EstudoFormDespesasDiaDiaDespesasTemporarias
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormProjetoVidaSonho ?
                                                                                            
                                                                            <EstudoFormProjetoVidaSonho
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormGarantiasPatrimonioImobilizado ?
                                                                                            
                                                                            <EstudoFormGarantiasPatrimonioImobilizado
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormGarantiasReceitaMensal ?
                                                                                            
                                                                            <EstudoFormGarantiasReceitaMensal
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela ===
                                                                            HARDCODE.estudoFormGarantiasRecursosFinanceiros ?
                                                                                            
                                                                            <EstudoFormGarantiasRecursosFinanceiros
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormSeguroVida ?
                                                                                            
                                                                            <EstudoFormSeguroVida
                                                                                values={values}
                                                                                estudo={estudo}
                                                                                report={report}
                                                                                //indInicial={item.indInicial}
                                                                                //indFinal={item.indFinal}
                                                                            />
                                            
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.mapaFinanceiroFormGrafico ?
                                                                                        
                                                                            <MapaFinanceiroFormGrafico
                                                                                values={values}
                                                                                report={report}
                                                                            />
                                                                                                                
                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormComparacaoCenariosGrafico ?
                                                                                        
                                                                            <ComparacaoCenariosEstudosChart
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                estudo={estudo}
                                                                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                jsonPagina={vars.jsonPagina}
                                                                                jsonUsuario={vars.jsonUsuario}
                                                                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                                                report={report}
                                                                                comparacaoCenariosEstudosTipo={
                                                                                    HARDCODE.comparacaoCenariosEstudosTipoCenario
                                                                                }
                                                                                simulacaoFinanceira={false}
                                                                            />

                                                                        : linhaItemPagina.graficoTabela === HARDCODE.estudoFormComparacaoCenarios ?
                                                                                        
                                                                            <EstudoFormComparacaoCenariosEstudos
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                estudo={estudo}
                                                                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                jsonPagina={vars.jsonPagina}
                                                                                jsonUsuario={vars.jsonUsuario}
                                                                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                                                report={report}
                                                                                comparacaoCenariosEstudosTipo={
                                                                                    HARDCODE.comparacaoCenariosEstudosTipoCenario
                                                                                }
                                                                                simulacaoFinanceira={false}
                                                                            />
                                                                            
                                                                        : linhaItemPagina.graficoTabela ===
                                                                            HARDCODE.estudoFormComparacaoEstudosGrafico &&
                                                                                exibirPagina(HARDCODE.estudoFormComparacaoEstudosGrafico) ?
                                                                                        
                                                                            <ComparacaoCenariosEstudosChart
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                estudo={estudo}
                                                                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                jsonPagina={vars.jsonPagina}
                                                                                jsonUsuario={vars.jsonUsuario}
                                                                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                                                report={report}
                                                                                comparacaoCenariosEstudosTipo={
                                                                                    HARDCODE.comparacaoCenariosEstudosTipoEstudo
                                                                                }
                                                                                simulacaoFinanceira={false}
                                                                            />
                                                                            
                                                                        : linhaItemPagina.graficoTabela ===
                                                                            HARDCODE.estudoFormComparacaoEstudos &&
                                                                                exibirPagina(HARDCODE.estudoFormComparacaoEstudos) ?
                                                                                        
                                                                            <EstudoFormComparacaoCenariosEstudos
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                estudo={estudo}
                                                                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                                jsonPagina={vars.jsonPagina}
                                                                                jsonUsuario={vars.jsonUsuario}
                                                                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                                                report={report}
                                                                                comparacaoCenariosEstudosTipo={
                                                                                    HARDCODE.comparacaoCenariosEstudosTipoEstudo
                                                                                }
                                                                                simulacaoFinanceira={false}
                                                                            />

                                                                        : 
                                                                            ''
                                                                        }
                                                                    </div>
                                                                )
                                                })}
                                            </>
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                ))

                            :
                                <div
                                    key={index}
                                />
                    })}

                    {!values.modoApresentacao && !pesquisaList(values.reportImprimir, HARDCODE.estudoReportDisclaimer).id && (
                        <EstudoReportPage
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            vars={vars}
                            cabecalho={LABEL.disclaimer}
                            conteudo={
                                <EstudoReportDisclaimer
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                />
                            }
                            pagina={obtemPagina(pagina)}
                        />
                    )}
                </>
            }
        />
    )
}

export default EstudoReport